var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigliveEmptyState3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0257 27.1426C6.67506 27.1426 2.46261 31.3899 2.88688 36.3571L5.34836 65.0036C5.72886 69.4385 9.70561 72.8569 14.4871 72.8569H85.513C90.2911 72.8569 94.2679 69.4385 94.6518 65.0036L97.1132 36.3571C97.5409 31.3933 93.3251 27.1426 87.9745 27.1426H12.0257Z",
    fill: "#CCE2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3066 75.5191V56.4082H73.5209V75.7726L49.5281 80.0004L26.3066 75.5191Z",
    fill: "white",
    stroke: "#215AA8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4785 75.4152V54.8975L49.5642 58.0969V79.7966L26.4785 75.4152Z",
    fill: "#D3DEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4785 54.8975L49.5642 58.0969V79.7966",
    stroke: "#215AA8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7247 57.7004L42.8425 65.0955L19.6211 57.8611L25.8675 51.6122L19.639 45.3812L42.864 40L49.739 44.6385L57.4711 40L80.3318 46.2203L73.7604 51.6122L80.364 57.0291L59.1854 65.0955L49.7247 57.7004Z",
    fill: "white",
    stroke: "#215AA8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6357 51.6013L49.7429 44.6133L73.0179 51.6013L49.7429 57.7574L26.6357 51.6013Z",
    fill: "#7A9CCB",
    stroke: "#215AA8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6357 51.6015L49.5643 44.667V57.7111L26.6357 51.6015Z",
    fill: "#D3DEEE",
    stroke: "#215AA8"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4681 45.7145C75.2316 45.7145 80.7145 40.2316 80.7145 33.4681C80.7145 26.7046 75.2316 21.2217 68.4681 21.2217C61.7046 21.2217 56.2217 26.7046 56.2217 33.4681C56.2217 40.2316 61.7046 45.7145 68.4681 45.7145Z",
    fill: "#0045A3"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2464 44.4929C74.0099 44.4929 79.4929 39.0099 79.4929 32.2464C79.4929 25.4829 74.0099 20 67.2464 20C60.4829 20 55 25.4829 55 32.2464C55 39.0099 60.4829 44.4929 67.2464 44.4929Z",
    fill: "#3378D6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5712 37.9538H65.5569C65.3533 37.9538 65.1569 37.9217 64.9676 37.8467C64.7783 37.7717 64.6105 37.6609 64.4676 37.5181L61.2462 34.3467C61.1033 34.2074 60.9891 34.0431 60.9105 33.8574C60.8319 33.6752 60.7891 33.4788 60.7891 33.2788C60.7891 33.0788 60.8248 32.8824 60.8998 32.6967C60.9748 32.5109 61.0855 32.3431 61.2248 32.2002C61.3676 32.0574 61.5319 31.9431 61.7176 31.8681C61.8998 31.7895 62.0998 31.7574 62.2998 31.7502C62.4998 31.7502 62.6962 31.7859 62.8819 31.8645C63.0676 31.9395 63.2355 32.0502 63.3783 32.1931L65.4998 34.2824L72.2176 27.2288C72.4962 26.9359 72.8748 26.7681 73.2783 26.7574C73.6819 26.7467 74.0676 26.8967 74.3605 27.1752C74.6533 27.4538 74.8212 27.8324 74.8319 28.2359C74.8426 28.6395 74.6926 29.0252 74.4141 29.3181L66.6355 37.4895C66.4962 37.6359 66.3319 37.7502 66.1462 37.8324C65.9641 37.9109 65.7712 37.9538 65.5748 37.9609L65.5712 37.9538Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigliveEmptyState3);
export default __webpack_public_path__ + "static/media/siglive-empty-state-3.aff6bd38a86a1f20f071eaf62e75dd45.svg";
export { ForwardRef as ReactComponent };